import React, { useContext } from 'react';
import { Box, Typography, Link, Grid } from '@mui/material';
import { HomeownerPortalWrapper } from '../components/homeowner-portal-wrapper';
import communityHero from '../../../assets/homeowner-portal/temporary_background.png';
import { HeroSection, BuildsDropdown } from '../components';
import { UserContext } from '../../../context';
import { BuildPhotosCarousel } from './build-photos-carousel/build-photos-carousel';
import { PhasesStepper } from './phases-stepper';
import { MessageBuildTeam } from './message-build-team';

export const PhasesOfConstruction = () => {
  const { user } = useContext(UserContext);
  const personId = user?.externalUser?.personId;
  const firstName = user?.fullName?.split(' ')[0] || user?.userName || 'Purchaser';

  return (
    <HomeownerPortalWrapper title="Phases of Construction">
      <Box sx={{ flex: 1 }}>
        <HeroSection
          image={communityHero}
          title="Phases of Construction"
          subtitle="All the information you need for ---"
          variant="small"
        />
        <Box sx={{ mb: 2, mt: 4, mx: 4 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={8}>
              <Typography variant="h3">
                Hi {firstName}, Welcome to your Homeowner Portal!
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
                mt: { xs: 2, md: 0 }
              }}
            >
              <BuildsDropdown sx={{ minWidth: { xs: '100%', md: 280 } }} />
            </Grid>
          </Grid>
        </Box>
        <Typography mb={2} ml={4} mr={4} sx={{ fontStyle: 'italic' }}>
          Throughout each phase of construction, you’ll receive weekly photo updates right here and
          phase communication updates via email from{' '}
          <Link
            href="mailto:hello@stonemartin.com"
            sx={{ color: 'inherit', textDecoration: 'none' }}
          >
            hello@stonemartin.com
          </Link>
          , so you can stay connected to the progress of your new home. In addition to photos here
          in the portal, your email updates will include helpful information about what’s happening
          in your home during each phase of construction—so you’re always informed and in the loop.
          You can also reference this portal anytime to see what’s coming up next. We’re honored to
          be building your home and thrilled to share this journey with you!
        </Typography>
        <PhasesStepper />
        {personId && (
          <>
            <BuildPhotosCarousel />
            <MessageBuildTeam />
          </>
        )}
      </Box>
    </HomeownerPortalWrapper>
  );
};
